import {getArticleDetails} from '../article-details';
import {publishEvent} from '../pub-sub';
import {ANALYTIC_EVENTS} from '../pub-sub/constants';

const CommentsEventLogger = {
  clickCommentsButton: articleId => publishEvent(ANALYTIC_EVENTS.COMMENTS, {
    ...getArticleDetails(articleId),
    action_target: 'click_discussion'
  }),
  goFromUrl: articleId => publishEvent(ANALYTIC_EVENTS.COMMENTS, {
    ...getArticleDetails(articleId),
    action_target: 'click_comments_from_url'
  }),
  showCommentsModal: articleId => publishEvent(ANALYTIC_EVENTS.ARTICLE_COMMENTS_OBSERVE, {
    ...getArticleDetails(articleId)
  }),
  openFromCommentsButtonError: (errorMessage, articleId) => publishEvent(ANALYTIC_EVENTS.COMMENTS, {
    ...getArticleDetails(articleId),
    action_target: 'open_comments_feed_from_discussion_error',
    error_message: errorMessage
  }),
  openFromUrlError: (errorMessage, articleId) => publishEvent(ANALYTIC_EVENTS.COMMENTS, {
    ...getArticleDetails(articleId),
    action_target: 'open_comments_feed_from_url_error',
    error_message: errorMessage
  }),
  fillMainComment: articleId => publishEvent(ANALYTIC_EVENTS.COMMENTS, {
    ...getArticleDetails(articleId),
    action_target: 'change_root_text_area'
  }),
  fillChildComment: articleId => publishEvent(ANALYTIC_EVENTS.COMMENTS, {
    ...getArticleDetails(articleId),
    action_target: 'change_reply_text_area'
  }),
  clickCancelButtonOnMainComment: articleId => publishEvent(ANALYTIC_EVENTS.COMMENTS, {
    ...getArticleDetails(articleId),
    action_target: 'click_cancel_root_comment'
  }),
  clickCancelButtonOnChildComment: articleId => publishEvent(ANALYTIC_EVENTS.COMMENTS, {
    ...getArticleDetails(articleId),
    action_target: 'click_cancel_reply'
  }),
  publishMainComment: articleId => publishEvent(ANALYTIC_EVENTS.COMMENTS, {
    ...getArticleDetails(articleId),
    action_target: 'click_send_root_comment'
  }),
  publishMainCommentSuccess: articleId => publishEvent(ANALYTIC_EVENTS.COMMENTS, {
    ...getArticleDetails(articleId),
    action_target: 'click_send_root_comment_success'
  }),
  publishMainCommentError: (errorMessage, articleId) => publishEvent(ANALYTIC_EVENTS.COMMENTS, {
    ...getArticleDetails(articleId),
    action_target: 'click_send_root_comment_error',
    error_message: errorMessage
  }),
  clickReplyButton: articleId => publishEvent(ANALYTIC_EVENTS.COMMENTS, {
    ...getArticleDetails(articleId),
    action_target: 'click_reply_button'
  }),
  publishChildCommentReply: articleId => publishEvent(ANALYTIC_EVENTS.COMMENTS, {
    ...getArticleDetails(articleId),
    action_target: 'click_send_reply'
  }),
  publishChildCommentReplySuccess: articleId => publishEvent(ANALYTIC_EVENTS.COMMENTS, {
    ...getArticleDetails(articleId),
    action_target: 'click_send_reply_success'
  }),
  publishChildCommentReplyError: (errorMessage, articleId) => publishEvent(ANALYTIC_EVENTS.COMMENTS, {
    ...getArticleDetails(articleId),
    action_target: 'click_send_reply_error',
    error_message: errorMessage
  }),
  clickOutsideModal: articleId => publishEvent(ANALYTIC_EVENTS.COMMENTS, {
    ...getArticleDetails(articleId),
    action_target: 'click_out_of_comments_feed'
  }),
  clickCloseButton: articleId => publishEvent(ANALYTIC_EVENTS.COMMENTS, {
    ...getArticleDetails(articleId),
    action_target: 'click_exit'
  })
};

export {CommentsEventLogger};
